/* MK Domus - animações e acabamento. Degrada sem quebrar: se algo falhar,
   a página volta ao estado normal, com todo o conteúdo visível. */
(function () {
  var root = document.documentElement;
  var temIO = 'IntersectionObserver' in window;
  if (!temIO) return;

  root.classList.add('mk-anim');

  /* rede de segurança: se algo der errado, tudo aparece em 2,5s */
  var reserva = setTimeout(function () {
    document.querySelectorAll('[data-mkr]').forEach(function (el) { el.classList.add('is-in'); });
  }, 2500);

  function pronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  pronto(function () {
    /* ---------- 1. entrada ao rolar ---------- */
    var alvos = document.querySelectorAll('.mk-sec, .mkwhy__card, .mk-collhead, .mkb, .mkst');
    alvos.forEach(function (el, i) {
      el.setAttribute('data-mkr', '');
      el.style.transitionDelay = (Math.min(i, 3) * 60) + 'ms';
    });

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

    alvos.forEach(function (el) { obs.observe(el); });

    /* o que já está na tela aparece de imediato */
    requestAnimationFrame(function () {
      alvos.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('is-in');
      });
    });
    clearTimeout(reserva);

    /* ---------- 2. imagens aparecendo suave ---------- */
    document.querySelectorAll('.mkc__media img, .mkp__media img').forEach(function (img) {
      if (img.complete) img.classList.add('is-on');
      else img.addEventListener('load', function () { img.classList.add('is-on'); });
      img.addEventListener('error', function () { img.classList.add('is-on'); });
    });

    /* ---------- 3. setas nas vitrines ---------- */
    var SVG_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    var SVG_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

    document.querySelectorAll('.mk-rail').forEach(function (rail) {
      var pai = rail.parentElement;
      if (!pai) return;
      pai.classList.add('mk-railwrap');

      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = 'mk-arrow mk-arrow--prev';
      next.className = 'mk-arrow mk-arrow--next';
      prev.setAttribute('aria-label', 'Ver anteriores');
      next.setAttribute('aria-label', 'Ver próximos');
      prev.innerHTML = SVG_L;
      next.innerHTML = SVG_R;
      pai.appendChild(prev);
      pai.appendChild(next);

      function passo() {
        var card = rail.querySelector('.mkc');
        var l = card ? card.getBoundingClientRect().width + 14 : 226;
        return Math.max(l, Math.round(rail.clientWidth * 0.8));
      }
      function marcar() {
        var max = rail.scrollWidth - rail.clientWidth;
        var some = max < 8;
        prev.hidden = some || rail.scrollLeft <= 4;
        next.hidden = some || rail.scrollLeft >= max - 4;
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -passo(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: passo(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', marcar, { passive: true });
      window.addEventListener('resize', marcar);
      marcar();
    });
  });
})();
